<template>

    <Toast/>

    <MenuFinancialCompact v-if="userStore.user?.roles?.includes('ROLE_ISORISE')"/>
    <MenuHealthCompact v-else/>

    <div class="px-6 surface-overlay relative">

        <ul class="list-none py-2 px-0 m-0 flex align-items-center font-medium overflow-x-auto w-full">
            <li class="pr-3"><a class="cursor-pointer">Financial Clarity</a></li>
            <li class="px-2"><i class="pi pi-angle-right text-900"></i></li>
            <li class="px-2"><a class="cursor-pointer text-900 white-space-nowrap">Reports</a></li>
        </ul>

        <div v-show="activeTab === 0" class="grid">
            <div class="col-12 md:col-12">
                <div class="card p-fluid">

                    <h3>Manage Reports</h3>

                    <span>
                        No reports loaded.
                    </span>
                </div>
            </div>
        </div>

        <div v-show="activeTab === 1" class="grid">
            <div class="col-12 md:col-12">
                <div class="card p-fluid">

                    <h3>Manage Reports</h3>

                    <h4>Task Related</h4>

                    <ul class="list-none m-0 p-0">
                        <li @click="callTaskRelatedReport01"
                            class="select-none p-2 font-medium text-base cursor-pointer border-round-lg hover:surface-hover hover:text-primary flex justify-content-between align-items-center">
                                                        <span class="flex align-items-center"><i
                                                            class="pi pi-file mr-2"></i>List of Tasks by User</span>
                        </li>
                    </ul>

                    <ul class="list-none m-0 p-0">
                        <li @click="callTaskRelatedReport02"
                            class="select-none p-2 font-medium text-base cursor-pointer border-round-lg hover:surface-hover hover:text-primary flex justify-content-between align-items-center">
                                                        <span class="flex align-items-center"><i
                                                            class="pi pi-file mr-2"></i>Time Spent on Processes by User</span>
                        </li>
                    </ul>

                    <ul class="list-none m-0 p-0">
                        <li @click="callTaskRelatedReport03"
                            class="select-none p-2 font-medium text-base cursor-pointer border-round-lg hover:surface-hover hover:text-primary flex justify-content-between align-items-center">
                                                        <span class="flex align-items-center"><i
                                                            class="pi pi-file mr-2"></i>Task Performance by User</span>
                        </li>
                    </ul>

                    <h4>Financial Related</h4>

                    <ul class="list-none m-0 p-0">
                        <li @click="callFinancialRelatedReport01"
                            class="select-none p-2 font-medium text-base cursor-pointer border-round-lg hover:surface-hover hover:text-primary flex justify-content-between align-items-center">
                                                        <span class="flex align-items-center"><i
                                                            class="pi pi-file mr-2"></i>Financial Summary</span>
                        </li>
                    </ul>

                    <ul class="list-none m-0 p-0">
                        <li @click="callFinancialRelatedReport02"
                            class="select-none p-2 font-medium text-base cursor-pointer border-round-lg hover:surface-hover hover:text-primary flex justify-content-between align-items-center">
                                                        <span class="flex align-items-center"><i
                                                            class="pi pi-file mr-2"></i>Transaction Summary</span>
                        </li>
                    </ul>

                    <ul v-if="companyConfiguration.type === 'H'" class="list-none m-0 p-0">
                        <li @click="callFinancialRelatedReport03"
                            class="select-none p-2 font-medium text-base cursor-pointer border-round-lg hover:surface-hover hover:text-primary flex justify-content-between align-items-center">
                                                        <span class="flex align-items-center"><i
                                                            class="pi pi-file mr-2"></i>Practitioner Transaction Summary</span>
                        </li>
                    </ul>

                    <ul class="list-none m-0 p-0">
                        <li @click="callFinancialRelatedReport04"
                            class="select-none p-2 font-medium text-base cursor-pointer border-round-lg hover:surface-hover hover:text-primary flex justify-content-between align-items-center">
                                                        <span class="flex align-items-center"><i
                                                            class="pi pi-file mr-2"></i>Detailed Transaction Summary</span>
                        </li>
                    </ul>

                    <ul class="list-none m-0 p-0">
                        <li @click="callFinancialRelatedReport05"
                            class="select-none p-2 font-medium text-base cursor-pointer border-round-lg hover:surface-hover hover:text-primary flex justify-content-between align-items-center">
                                                        <span class="flex align-items-center"><i
                                                            class="pi pi-file mr-2"></i>Detailed Summary of Appointments, Invoices and Payments</span>
                        </li>
                    </ul>

                    <ul class="list-none m-0 p-0">
                        <li @click="callFinancialRelatedReport06"
                            class="select-none p-2 font-medium text-base cursor-pointer border-round-lg hover:surface-hover hover:text-primary flex justify-content-between align-items-center">
                                                        <span class="flex align-items-center"><i
                                                            class="pi pi-file mr-2"></i>Appointment Detail</span>
                        </li>
                    </ul>

                </div>
            </div>
        </div>


        <div v-show="activeTab === 2" class="grid">
            <div class="col-12 md:col-12">
                <div class="card p-fluid">

                    <h3>List of Tasks by User</h3>

                    <div class="field">
                        <label for="user">User</label>
                        <AutoComplete placeholder="Select" :dropdown="true" :multiple="false"
                                      v-model="reportInfo.user" :suggestions="filteredUsers"
                                      @complete="searchUsers($event)" field="username"/>
                    </div>

                    <div class="field">
                        <label for="startDate">Start Date</label>
                        <Calendar id="startDate" v-model="reportInfo.startDate" required="true"
                                  :showTime="true"
                                  :showSeconds="true" :showIcon="true" dateFormat="yy-mm-dd"/>

                    </div>

                    <div class="field">
                        <label for="endDate">End Date</label>
                        <Calendar id="endDate" v-model="reportInfo.endDate" required="true"
                                  :showTime="true"
                                  :showSeconds="true" :showIcon="true" dateFormat="yy-mm-dd"/>

                    </div>

                    <Button label="View" class="mr-2 mb-2" @click="viewTaskRelatedReport01"></Button>
                    <Button label="Email" class="mr-2 mb-2" @click="emailTaskRelatedReport01"></Button>
                    <Button label="Cancel" class="mr-2 mb-2" @click="callReset"></Button>

                </div>
            </div>
        </div>

        <div v-show="activeTab === 3" class="grid">
            <div class="col-12 md:col-12">
                <div class="card p-fluid">

                    <h3>Tasks per User</h3>

                    <div class="grid">
                        <ul class="list-none p-0 m-0 flex lg:align-items-center flex-column lg:flex-row select-none">
                            <li>
                                <a @click="callReset" v-ripple
                                   class="flex p-3 align-items-center text-600 hover:text-900 hover:surface-100 font-medium border-round cursor-pointer transition-colors transition-duration-150 p-ripple">
                                    <i class="pi pi-plus-circle mr-2"></i>
                                    <span>Back to Reports</span>
                                </a>
                            </li>
                        </ul>
                    </div>

                    <DataTable :value="tasksPerUser" :paginator="true" class="p-datatable-gridlines"
                               :rows="100" dataKey="id"
                               :rowsPerPageOptions="[10,20,50,100]"
                               :rowHover="true"
                               striped-rows
                               v-model:filters="filters1" filterDisplay="menu" :loading="loading1"
                               :filters="filters1"
                               responsiveLayout="scroll"
                               :globalFilterFields="['processName', 'taskDescription']">

                        <template #header>
                            <div class="p-d-flex p-jc-between p-flex-column p-flex-sm-row">
                                <Button type="button" icon="pi pi-filter-slash" label="Clear"
                                        class="p-button-outlined p-mb-2"
                                        @click="clearFilter1()"/>
                                <br><br>
                                <span class="p-input-icon-left p-mb-2">
                                                <i class="pi pi-search"/>
                                                <InputText v-model="filters1['global'].value"
                                                           placeholder="Keyword Search on Process Name or Task Description"
                                                           style="width: 100%"/>
                                            </span>
                            </div>
                        </template>

                        <template #empty>
                            No tasks found.
                        </template>

                        <template #loading>
                            Loading task data. Please wait.
                        </template>

                        <Column field="status" header="Status" style="max-width:9rem">
                            <template #body="{data}">
                                <span class="p-column-title">Status</span>
                                <span v-if="data.taskStatus === 'I'"
                                      :class="'status-badge status-' + data.taskStatus">Initiated</span>
                                <span v-if="data.taskStatus === 'W'"
                                      :class="'status-badge status-' + data.taskStatus">Working On It</span>
                                <span v-if="data.taskStatus === 'C'"
                                      :class="'status-badge status-' + data.taskStatus">Completed</span>
                                <span v-if="data.taskStatus === 'R'"
                                      :class="'status-badge status-' + data.taskStatus">Rejected and Closed</span>

                            </template>
                        </Column>

                        <Column field="processName" header="Process Name" style="max-width:9rem">
                            <template #body="{data}">
                                <span class="p-column-title">Process Name</span>
                                {{ data.processName }}
                            </template>
                        </Column>

                        <Column field="type" header="Type" style="max-width:11rem">
                            <template #body="{data}">
                                <span class="p-column-title">Type</span>
                                <span v-if="data.taskType === 'S'"
                                      :class="'type-badge status-' + data.taskType">Software Support</span>
                                <span v-if="data.taskType === 'B'"
                                      :class="'type-badge status-' + data.taskType">Billing</span>
                                <span v-if="data.taskType === 'C'"
                                      :class="'type-badge status-' + data.taskType">Client Management</span>
                                <span v-if="data.taskType === 'U'"
                                      :class="'type-badge status-' + data.taskType">Unpaids Management</span>
                                <span v-if="data.taskType === 'P'"
                                      :class="'type-badge status-' + data.taskType">Payment Management</span>
                                <span v-if="data.taskType === 'O'"
                                      :class="'type-badge status-' + data.taskType">Other</span>
                                <span v-if="data.taskType === 'D'"
                                      :class="'type-badge status-' + data.taskType">Administration</span>
                                <span v-if="data.taskType === 'E'"
                                      :class="'type-badge status-' + data.taskType">New Business</span>
                                <span v-if="data.taskType === 'F'"
                                      :class="'type-badge status-' + data.taskType">Benefit Query</span>
                                <span v-if="data.taskType === 'G'"
                                      :class="'type-badge status-' + data.taskType">Authorisation</span>
                                <span v-if="data.taskType === 'H'"
                                      :class="'type-badge status-' + data.taskType">Claims</span>
                            </template>
                        </Column>

                        <Column field="description" header="Description" style="min-width:12rem">
                            <template #body="{data}">
                                <span class="p-column-title">Description</span>
                                {{ data.taskDescription }}
                            </template>

                            <template #footer>
                                Total
                            </template>
                        </Column>

                        <Column field="created" header="Created" style="max-width:10rem">
                            <template #body="{data}">
                                <span class="p-column-title">Created</span>
                                {{ formatDate(data.taskStart) }}
                            </template>
                        </Column>

                        <Column field="completed" header="Completed" style="max-width:10rem">
                            <template #body="{data}">
                                <span class="p-column-title">Completed</span>
                                {{ formatDate(data.taskEnd) }}
                            </template>
                        </Column>

                        <Column field="duration" header="Duration" style="max-width:6rem">
                            <template #body="{data}">
                                <span class="p-column-title">Duration</span>
                                {{ formatTimeInHours(data.taskDuration) }}
                            </template>

                            <template #footer>
                                {{ formatTimeInHours(totalTaskDuration) }}
                            </template>
                        </Column>

                    </DataTable>

                </div>
            </div>
        </div>


        <div v-show="activeTab === 4" class="grid">
            <div class="col-12 md:col-12">
                <div class="card p-fluid">

                    <h3>Time Spent on Processes by User</h3>

                    <div class="field">
                        <label for="user">User</label>
                        <AutoComplete placeholder="Select" :dropdown="true" :multiple="false"
                                      v-model="reportInfo.user" :suggestions="filteredUsers"
                                      @complete="searchUsers($event)" field="username"/>
                    </div>

                    <div class="field">
                        <label for="startDate">Start Date</label>
                        <Calendar id="startDate" v-model="reportInfo.startDate" required="true"
                                  :showTime="true"
                                  :showSeconds="true" :showIcon="true" dateFormat="yy-mm-dd"/>

                    </div>

                    <div class="field">
                        <label for="endDate">End Date</label>
                        <Calendar id="endDate" v-model="reportInfo.endDate" required="true"
                                  :showTime="true"
                                  :showSeconds="true" :showIcon="true" dateFormat="yy-mm-dd"/>

                    </div>

                    <Button label="View" class="mr-2 mb-2" @click="viewTaskRelatedReport02"></Button>
                    <Button label="Email" class="mr-2 mb-2" @click="emailTaskRelatedReport02"></Button>
                    <Button label="Cancel" class="mr-2 mb-2" @click="callReset"></Button>

                </div>
            </div>
        </div>


        <div v-show="activeTab === 5" class="grid">
            <div class="col-12 md:col-12">
                <div class="card p-fluid">

                    <h3>Time Spent on Processes by User</h3>

                    <div class="field">
                        <label for="user">User</label>
                        <AutoComplete placeholder="Select" :dropdown="true" :multiple="false"
                                      v-model="reportInfo.user" :suggestions="filteredUsers"
                                      @complete="searchUsers($event)" field="username"/>
                    </div>

                    <div class="field">
                        <label for="startDate">Start Date</label>
                        <Calendar id="startDate" v-model="reportInfo.startDate" required="true"
                                  :showTime="true"
                                  :showSeconds="true" :showIcon="true" dateFormat="yy-mm-dd"/>

                    </div>

                    <div class="field">
                        <label for="endDate">End Date</label>
                        <Calendar id="endDate" v-model="reportInfo.endDate" required="true"
                                  :showTime="true"
                                  :showSeconds="true" :showIcon="true" dateFormat="yy-mm-dd"/>

                    </div>

                    <Button label="View" class="mr-2 mb-2" @click="viewTaskRelatedReport02"></Button>
                    <Button label="Email" class="mr-2 mb-2" @click="emailTaskRelatedReport02"></Button>
                    <Button label="Cancel" class="mr-2 mb-2" @click="callReset"></Button>

                </div>
            </div>
        </div>


        <div v-show="activeTab === 6" class="grid">
            <div class="col-12 md:col-12">
                <div class="card p-fluid">

                    <h3>Time Spent on Processes by User</h3>

                    <div class="grid">
                        <ul class="list-none p-0 m-0 flex lg:align-items-center flex-column lg:flex-row select-none">
                            <li>
                                <a @click="callReset" v-ripple
                                   class="flex p-3 align-items-center text-600 hover:text-900 hover:surface-100 font-medium border-round cursor-pointer transition-colors transition-duration-150 p-ripple">
                                    <i class="pi pi-plus-circle mr-2"></i>
                                    <span>Back to Reports</span>
                                </a>
                            </li>
                        </ul>
                    </div>

                    <DataTable ref="tasksProcessDurationPerUserTable" :value="tasksProcessDurationPerUser"
                               dataKey="processName"
                               :paginator="true"
                               :rows="20"
                               paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                               :rowsPerPageOptions="[10,20,30]"
                               currentPageReportTemplate="Showing {first} to {last} of {totalRecords} processes"
                               striped-rows
                               responsiveLayout="scroll">

                        <Column field="processName" header="Process Name" :sortable="true">
                            <template #body="slotProps">
                                <span class="p-column-title">Process Name</span>
                                {{ slotProps.data.processName }}
                            </template>
                        </Column>

                        <Column field="taskDuration" header="Task Duration" :sortable="true">
                            <template #body="slotProps">
                                <span class="p-column-title">Task Duration</span>
                                {{ formatTimeInHours(slotProps.data.taskDuration) }}
                            </template>
                        </Column>
                    </DataTable>

                </div>
            </div>
        </div>


        <div v-show="activeTab === 7" class="grid">
            <div class="col-12 md:col-12">
                <div class="card p-fluid">

                    <h3>Task Performance by User</h3>

                    <div class="field">
                        <label for="user">User</label>
                        <AutoComplete placeholder="Select" :dropdown="true" :multiple="false"
                                      v-model="reportInfo.user" :suggestions="filteredUsers"
                                      @complete="searchUsers($event)" field="username"/>
                    </div>

                    <div class="field">
                        <label for="startDate">Start Date</label>
                        <Calendar id="startDate" v-model="reportInfo.startDate" required="true"
                                  :showTime="true"
                                  :showSeconds="true" :showIcon="true" dateFormat="yy-mm-dd"/>

                    </div>

                    <div class="field">
                        <label for="endDate">End Date</label>
                        <Calendar id="endDate" v-model="reportInfo.endDate" required="true"
                                  :showTime="true"
                                  :showSeconds="true" :showIcon="true" dateFormat="yy-mm-dd"/>

                    </div>

                    <Button label="View" class="mr-2 mb-2" @click="viewTaskRelatedReport03"></Button>
                    <Button label="Email" class="mr-2 mb-2" @click="emailTaskRelatedReport03"></Button>
                    <Button label="Cancel" class="mr-2 mb-2" @click="callReset"></Button>

                </div>
            </div>
        </div>


        <div v-show="activeTab === 8" class="grid">
            <div class="col-12 md:col-12">
                <div class="card p-fluid">

                    <h3>Task Performance by User</h3>

                    <div class="grid">
                        <ul class="list-none p-0 m-0 flex lg:align-items-center flex-column lg:flex-row select-none">
                            <li>
                                <a @click="callReset" v-ripple
                                   class="flex p-3 align-items-center text-600 hover:text-900 hover:surface-100 font-medium border-round cursor-pointer transition-colors transition-duration-150 p-ripple">
                                    <i class="pi pi-plus-circle mr-2"></i>
                                    <span>Back to Reports</span>
                                </a>
                            </li>
                        </ul>
                    </div>

                    <h3>Start of Tasks</h3>
                    {{ formatDate(this.tasksPerformancePerUser.taskStart) }}

                    <br><br>
                    <h3>End of Tasks</h3>
                    {{ formatDate(this.tasksPerformancePerUser.taskEnd) }}

                    <br><br>
                    <h3>Duration of Tasks</h3>
                    {{ formatTimeInHours(this.tasksPerformancePerUser.taskDuration) }}

                </div>
            </div>
        </div>

        <div v-show="activeTab === 9" class="grid">
            <div class="col-12 md:col-12">
                <div class="card p-fluid">

                    <h3>Financial Summary</h3>

                    <div class="field">
                        <label for="startDate">Start Date</label>
                        <Calendar id="startDate" v-model="reportInfo.startDate" required="true"
                                  :showTime="true"
                                  :showSeconds="true" :showIcon="true" dateFormat="yy-mm-dd"/>

                    </div>

                    <div class="field">
                        <label for="endDate">End Date</label>
                        <Calendar id="endDate" v-model="reportInfo.endDate" required="true"
                                  :showTime="true"
                                  :showSeconds="true" :showIcon="true" dateFormat="yy-mm-dd"/>

                    </div>

                    <Button label="View" class="mr-2 mb-2" @click="viewFinancialRelatedReport01"></Button>
                    <Button label="Email" class="mr-2 mb-2" @click="emailFinancialRelatedReport01"></Button>
                    <Button label="Cancel" class="mr-2 mb-2" @click="callReset"></Button>

                </div>
            </div>
        </div>

        <div v-show="activeTab === 10" class="grid">
            <div class="col-12 md:col-12">
                <div class="card p-fluid">

                    <h3>Financial Summary</h3>

                    <div class="grid">
                        <ul class="list-none p-0 m-0 flex lg:align-items-center flex-column lg:flex-row select-none">
                            <li>
                                <a @click="callReset" v-ripple
                                   class="flex p-3 align-items-center text-600 hover:text-900 hover:surface-100 font-medium border-round cursor-pointer transition-colors transition-duration-150 p-ripple">
                                    <i class="pi pi-plus-circle mr-2"></i>
                                    <span>Back to Reports</span>
                                </a>
                            </li>
                        </ul>
                    </div>

                    <h3>Invoice Summary</h3>
                    {{ formatAmount(this.financialSummary.invoiceSummary) }}

                    <br><br>
                    <h3>Payment Summary</h3>
                    {{ formatAmount(this.financialSummary.paymentSummary) }}

                </div>
            </div>
        </div>

        <div v-show="activeTab === 11" class="grid">
            <div class="col-12 md:col-12">
                <div class="card p-fluid">

                    <h3>Transaction Summary</h3>

                    <div class="field">
                        <label for="startDate">Start Date</label>
                        <Calendar id="startDate" v-model="reportInfo.startDate" required="true"
                                  :showTime="true"
                                  :showSeconds="true" :showIcon="true" dateFormat="yy-mm-dd"/>

                    </div>

                    <div class="field">
                        <label for="endDate">End Date</label>
                        <Calendar id="endDate" v-model="reportInfo.endDate" required="true"
                                  :showTime="true"
                                  :showSeconds="true" :showIcon="true" dateFormat="yy-mm-dd"/>

                    </div>

                    <Button label="View" class="mr-2 mb-2" :loading="submitted"
                            @click="viewFinancialRelatedReport02"></Button>
                    <Button label="Email" class="mr-2 mb-2" :loading="submitted"
                            @click="emailFinancialRelatedReport02"></Button>
                    <Button label="Cancel" class="mr-2 mb-2" :loading="submitted" @click="callReset"></Button>

                </div>
            </div>
        </div>

        <div v-show="activeTab === 12" class="grid">
            <div class="col-12 md:col-12">
                <div class="card p-fluid">

                    <h3>Transaction Summary</h3>

                    <div class="grid">
                        <ul class="list-none p-0 m-0 flex lg:align-items-center flex-column lg:flex-row select-none">
                            <li>
                                <a @click="callReset" v-ripple
                                   class="flex p-3 align-items-center text-600 hover:text-900 hover:surface-100 font-medium border-round cursor-pointer transition-colors transition-duration-150 p-ripple">
                                    <i class="pi pi-plus-circle mr-2"></i>
                                    <span>Back to Reports</span>
                                </a>
                            </li>
                        </ul>
                    </div>

                    <DataTable ref="transactionSummary" :value="transactionSummary" dataKey="invoiceNumber"
                               :paginator="true"
                               :rows="20"
                               paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                               :rowsPerPageOptions="[10,20,30]"
                               currentPageReportTemplate="Showing {first} to {last} of {totalRecords} transactions"
                               striped-rows
                               responsiveLayout="scroll">

                        <Column field="clientId" header="Client #" :sortable="true">
                            <template #body="slotProps">
                                <span class="p-column-title">Client #</span>
                                {{ slotProps.data.clientId }}
                            </template>
                        </Column>

                        <Column field="clientName" header="Client Name" :sortable="true">
                            <template #body="slotProps">
                                <span class="p-column-title">Client Name</span>
                                {{ slotProps.data.clientName }}
                            </template>
                        </Column>

                        <Column field="invoiceNumber" header="Invoice #" :sortable="true">
                            <template #body="slotProps">
                                <span class="p-column-title">Invoice #</span>
                                {{ slotProps.data.invoiceNumber }}
                            </template>
                        </Column>

                        <Column field="appointmentDate" header="Appointment Date" :sortable="true">
                            <template #body="slotProps">
                                <span class="p-column-title">Appointment Date</span>
                                {{ slotProps.data.appointmentDate }}
                            </template>
                        </Column>

                        <Column field="billingPlanName" header="Billing Plan Name" :sortable="true">
                            <template #body="slotProps">
                                <span class="p-column-title">Billing Plan Name</span>
                                {{ slotProps.data.billingPlanName }}
                            </template>
                        </Column>

                        <Column field="practitionerFullName" header="Practitioner Name" :sortable="true">
                            <template #body="slotProps">
                                <span class="p-column-title">Practitioner Name</span>
                                {{ slotProps.data.practitionerFullName }}
                            </template>
                        </Column>

                        <Column field="amount" header="Amount" :sortable="true">
                            <template #body="slotProps">
                                <span class="p-column-title">Amount</span>
                                {{ formatAmount(slotProps.data.amount) }}
                            </template>
                        </Column>

                        <Column field="paid" header="Paid" :sortable="true">
                            <template #body="slotProps">
                                <span class="p-column-title">Paid</span>
                                {{ formatAmount(slotProps.data.paid) }}
                            </template>
                        </Column>

                        <Column field="submissionMethod" header="Submission Method" :sortable="true">
                            <template #body="slotProps">
                                <span class="p-column-title">Submission Method</span>
                                <span v-if="slotProps.data.submissionMethod === 'C'"
                                      :class="'submission-badge status-' + slotProps.data.submissionMethod">Client</span>
                                <span v-if="slotProps.data.submissionMethod === 'B'"
                                      :class="'submission-badge status-' + slotProps.data.submissionMethod">Health Insurance</span>
                            </template>
                        </Column>

                        <Column field="status" header="Status" :sortable="true">
                            <template #body="slotProps">
                                <span class="p-column-title">Status</span>
                                <span v-if="slotProps.data.status === 'I'"
                                      :class="'status-badge status-' + slotProps.data.status">Unpaid</span>
                                <span v-if="slotProps.data.status === 'S'"
                                      :class="'status-badge status-' + slotProps.data.status">Submitted</span>
                                <span v-if="slotProps.data.status === 'P'"
                                      :class="'status-badge status-' + slotProps.data.status">Paid</span>
                                <span v-if="slotProps.data.status === 'U'"
                                      :class="'status-badge status-' + slotProps.data.status">Unpaids Process</span>
                                <span v-if="slotProps.data.status === 'C'"
                                      :class="'status-badge status-' + slotProps.data.status">Archived</span>
                                <span v-if="slotProps.data.status === 'M'"
                                      :class="'status-badge status-' + slotProps.data.status">Member Liable</span>
                            </template>
                        </Column>
                    </DataTable>

                    <br>
                    <h3>Total Amount Invoiced</h3>
                    {{ formatTotal(invoiceTotals.totalAmountInvoiced) }}

                    <br><br>
                    <h3>Actual Amount Received</h3>
                    {{ formatTotal(invoiceTotals.actualAmountReceived) }}

                </div>
            </div>
        </div>

        <div v-show="activeTab === 13" class="grid">
            <div class="col-12 md:col-12">
                <div class="card p-fluid">

                    <h3>Practitioner Transaction Summary</h3>

                    <div class="field">
                        <label for="startDate">Start Date</label>
                        <Calendar id="startDate" v-model="reportInfo.startDate" required="true"
                                  :showTime="true"
                                  :showSeconds="true" :showIcon="true" dateFormat="yy-mm-dd"/>

                    </div>

                    <div class="field">
                        <label for="endDate">End Date</label>
                        <Calendar id="endDate" v-model="reportInfo.endDate" required="true"
                                  :showTime="true"
                                  :showSeconds="true" :showIcon="true" dateFormat="yy-mm-dd"/>

                    </div>

                    <div class="field">
                        <label for="practitioner" class="text-900 font-semibold">Practitioner</label>
                        <Dropdown v-model="selectedPractitioner" :options="practitioners"
                                  optionLabel="fullName" optionValue="id" placeholder="Select a Practitioner"/>
                    </div>

                    <Button label="View" class="mr-2 mb-2" :loading="submitted"
                            @click="viewFinancialRelatedReport03"></Button>
                    <Button label="Email" class="mr-2 mb-2" :loading="submitted"
                            @click="emailFinancialRelatedReport03"></Button>
                    <Button label="Cancel" class="mr-2 mb-2" :loading="submitted" @click="callReset"></Button>

                </div>
            </div>
        </div>

        <div v-show="activeTab === 14" class="grid">
            <div class="col-12 md:col-12">
                <div class="card p-fluid">

                    <h3>Practitioner Transaction Summary</h3>

                    <div class="grid">
                        <ul class="list-none p-0 m-0 flex lg:align-items-center flex-column lg:flex-row select-none">
                            <li>
                                <a @click="callReset" v-ripple
                                   class="flex p-3 align-items-center text-600 hover:text-900 hover:surface-100 font-medium border-round cursor-pointer transition-colors transition-duration-150 p-ripple">
                                    <i class="pi pi-plus-circle mr-2"></i>
                                    <span>Back to Reports</span>
                                </a>
                            </li>
                        </ul>
                    </div>

                    <DataTable ref="transactionSummary" :value="transactionSummary" dataKey="invoiceNumber"
                               :paginator="true"
                               :rows="20"
                               paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                               :rowsPerPageOptions="[10,20,30]"
                               currentPageReportTemplate="Showing {first} to {last} of {totalRecords} transactions"
                               striped-rows
                               responsiveLayout="scroll">

                        <Column field="clientId" header="Client #" :sortable="true">
                            <template #body="slotProps">
                                <span class="p-column-title">Client #</span>
                                {{ slotProps.data.clientId }}
                            </template>
                        </Column>

                        <Column field="clientName" header="Client Name" :sortable="true">
                            <template #body="slotProps">
                                <span class="p-column-title">Client Name</span>
                                {{ slotProps.data.clientName }}
                            </template>
                        </Column>

                        <Column field="invoiceNumber" header="Invoice #" :sortable="true">
                            <template #body="slotProps">
                                <span class="p-column-title">Invoice #</span>
                                {{ slotProps.data.invoiceNumber }}
                            </template>
                        </Column>

                        <Column field="appointmentDate" header="Appointment Date" :sortable="true">
                            <template #body="slotProps">
                                <span class="p-column-title">Appointment Date</span>
                                {{ slotProps.data.appointmentDate }}
                            </template>
                        </Column>

                        <Column field="billingPlanName" header="Billing Plan Name" :sortable="true">
                            <template #body="slotProps">
                                <span class="p-column-title">Billing Plan Name</span>
                                {{ slotProps.data.billingPlanName }}
                            </template>
                        </Column>

                        <Column field="practitionerFullName" header="Practitioner Name" :sortable="true">
                            <template #body="slotProps">
                                <span class="p-column-title">Practitioner Name</span>
                                {{ slotProps.data.practitionerFullName }}
                            </template>
                        </Column>

                        <Column field="amount" header="Amount" :sortable="true">
                            <template #body="slotProps">
                                <span class="p-column-title">Amount</span>
                                {{ formatAmount(slotProps.data.amount) }}
                            </template>
                        </Column>

                        <Column field="paid" header="Paid" :sortable="true">
                            <template #body="slotProps">
                                <span class="p-column-title">Paid</span>
                                {{ formatAmount(slotProps.data.paid) }}
                            </template>
                        </Column>

                        <Column field="submissionMethod" header="Submission Method" :sortable="true">
                            <template #body="slotProps">
                                <span class="p-column-title">Submission Method</span>
                                <span v-if="slotProps.data.submissionMethod === 'C'"
                                      :class="'submission-badge status-' + slotProps.data.submissionMethod">Client</span>
                                <span v-if="slotProps.data.submissionMethod === 'B'"
                                      :class="'submission-badge status-' + slotProps.data.submissionMethod">Health Insurance</span>
                            </template>
                        </Column>

                        <Column field="status" header="Status" :sortable="true">
                            <template #body="slotProps">
                                <span class="p-column-title">Status</span>
                                <span v-if="slotProps.data.status === 'I'"
                                      :class="'status-badge status-' + slotProps.data.status">Unpaid</span>
                                <span v-if="slotProps.data.status === 'S'"
                                      :class="'status-badge status-' + slotProps.data.status">Submitted</span>
                                <span v-if="slotProps.data.status === 'P'"
                                      :class="'status-badge status-' + slotProps.data.status">Paid</span>
                                <span v-if="slotProps.data.status === 'U'"
                                      :class="'status-badge status-' + slotProps.data.status">Unpaids Process</span>
                                <span v-if="slotProps.data.status === 'C'"
                                      :class="'status-badge status-' + slotProps.data.status">Archived</span>
                                <span v-if="slotProps.data.status === 'M'"
                                      :class="'status-badge status-' + slotProps.data.status">Member Liable</span>
                            </template>
                        </Column>
                    </DataTable>

                    <br>
                    <h3>Total Amount Invoiced</h3>
                    {{ formatTotal(invoiceTotals.totalAmountInvoiced) }}

                    <br><br>
                    <h3>Actual Amount Received</h3>
                    {{ formatTotal(invoiceTotals.actualAmountReceived) }}

                </div>
            </div>
        </div>

        <div v-show="activeTab === 15" class="grid">
            <div class="col-12 md:col-12">
                <div class="card p-fluid">

                    <h4>Financial Related</h4>

                    <ul v-if="companyConfiguration.type === 'H'" class="list-none m-0 p-0">
                        <li @click="callUserFinancialRelatedReport01"
                            class="select-none p-2 font-medium text-base cursor-pointer border-round-lg hover:surface-hover hover:text-primary flex justify-content-between align-items-center">
                                                        <span class="flex align-items-center"><i
                                                            class="pi pi-file mr-2"></i>Practitioner Transaction Summary</span>
                        </li>
                    </ul>

                </div>
            </div>
        </div>


        <div v-show="activeTab === 16" class="grid">
            <div class="col-12 md:col-12">
                <div class="card p-fluid">

                    <h3>Detailed Transaction Summary</h3>

                    <div class="field">
                        <label for="startDate">Start Date</label>
                        <Calendar id="startDate" v-model="reportInfo.startDate" required="true"
                                  :showTime="true"
                                  :showSeconds="true" :showIcon="true" dateFormat="yy-mm-dd"/>

                    </div>

                    <div class="field">
                        <label for="endDate">End Date</label>
                        <Calendar id="endDate" v-model="reportInfo.endDate" required="true"
                                  :showTime="true"
                                  :showSeconds="true" :showIcon="true" dateFormat="yy-mm-dd"/>

                    </div>

                    <Button label="View" class="mr-2 mb-2" :loading="submitted"
                            @click="viewFinancialRelatedReport04"></Button>
                    <Button label="Email" class="mr-2 mb-2" :loading="submitted"
                            @click="emailFinancialRelatedReport04"></Button>
                    <Button label="Cancel" class="mr-2 mb-2" :loading="submitted" @click="callReset"></Button>

                </div>
            </div>
        </div>


        <div v-show="activeTab === 17" class="grid">
            <div class="col-12 md:col-12">
                <div class="card p-fluid">

                    <h3>Detailed Transaction Summary</h3>

                    <div class="grid">
                        <ul class="list-none p-0 m-0 flex lg:align-items-center flex-column lg:flex-row select-none">
                            <li>
                                <a @click="callReset" v-ripple
                                   class="flex p-3 align-items-center text-600 hover:text-900 hover:surface-100 font-medium border-round cursor-pointer transition-colors transition-duration-150 p-ripple">
                                    <i class="pi pi-plus-circle mr-2"></i>
                                    <span>Back to Reports</span>
                                </a>
                            </li>
                        </ul>
                    </div>

                    <DataTable ref="transactionSummary" :value="transactionSummary" dataKey="invoiceNumber"
                               :paginator="true"
                               :rows="20"
                               paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                               :rowsPerPageOptions="[10,20,30]"
                               currentPageReportTemplate="Showing {first} to {last} of {totalRecords} transactions"
                               striped-rows
                               responsiveLayout="scroll">

                        <Column field="date" header="Date" :sortable="true">
                            <template #body="slotProps">
                                <span class="p-column-title">Date</span>
                                {{ slotProps.data.date }}
                            </template>
                        </Column>

                        <Column field="type" header="Document Type" :sortable="true">
                            <template #body="slotProps">
                                <span class="p-column-title">Document Type</span>
                                {{ slotProps.data.type }}
                            </template>
                        </Column>

                        <Column field="clientId" header="Client #" :sortable="true">
                            <template #body="slotProps">
                                <span class="p-column-title">Client #</span>
                                {{ slotProps.data.clientId }}
                            </template>
                        </Column>

                        <Column field="clientName" header="Client Name" :sortable="true">
                            <template #body="slotProps">
                                <span class="p-column-title">Client Name</span>
                                {{ slotProps.data.clientName }}
                            </template>
                        </Column>

                        <Column field="invoiceNumber" header="Invoice #" :sortable="true">
                            <template #body="slotProps">
                                <span class="p-column-title">Invoice #</span>
                                {{ slotProps.data.uniqueId }}
                            </template>
                        </Column>

                        <Column field="paymentId" header="Payment #" :sortable="true">
                            <template #body="slotProps">
                                <span class="p-column-title">Payment #</span>
                                {{ slotProps.data.paymentId }}
                            </template>
                        </Column>

                        <Column field="amount" header="Amount" :sortable="true">
                            <template #body="slotProps">
                                <span class="p-column-title">Amount</span>
                                {{ formatAmount(slotProps.data.amount) }}
                            </template>
                        </Column>

                    </DataTable>

                    <br>
                    <h3>Total Amount Invoiced</h3>
                    {{ formatTotal(transactionTotals.totalAmountInvoiced) }}

                    <br><br>
                    <h3>Actual Amount Received</h3>
                    {{ formatTotal(transactionTotals.actualAmountReceived) }}

                </div>
            </div>
        </div>

        <div v-show="activeTab === 18" class="grid">
            <div class="col-12 md:col-12">
                <div class="card p-fluid">

                    <h3>Detailed Transaction Summary</h3>

                    <div class="field">
                        <label for="startDate">Start Date</label>
                        <Calendar id="startDate" v-model="reportInfo.startDate" required="true"
                                  :showTime="true"
                                  :showSeconds="true" :showIcon="true" dateFormat="yy-mm-dd"/>

                    </div>

                    <div class="field">
                        <label for="endDate">End Date</label>
                        <Calendar id="endDate" v-model="reportInfo.endDate" required="true"
                                  :showTime="true"
                                  :showSeconds="true" :showIcon="true" dateFormat="yy-mm-dd"/>

                    </div>

                    <Button label="View" class="mr-2 mb-2" :loading="submitted"
                            @click="viewFinancialRelatedReport05"></Button>
                    <Button label="Email" class="mr-2 mb-2" :loading="submitted"
                            @click="emailFinancialRelatedReport05"></Button>
                    <Button label="Cancel" class="mr-2 mb-2" :loading="submitted" @click="callReset"></Button>

                </div>
            </div>
        </div>

        <div v-show="activeTab === 19" class="grid">
            <div class="col-12 md:col-12">
                <div class="card p-fluid">

                    <h3>Detailed Summary of Appointments, Invoices and Payments</h3>

                    <div class="grid">
                        <ul class="list-none p-0 m-0 flex lg:align-items-center flex-column lg:flex-row select-none">
                            <li>
                                <a @click="callReset" v-ripple
                                   class="flex p-3 align-items-center text-600 hover:text-900 hover:surface-100 font-medium border-round cursor-pointer transition-colors transition-duration-150 p-ripple">
                                    <i class="pi pi-plus-circle mr-2"></i>
                                    <span>Back to Reports</span>
                                </a>
                            </li>
                        </ul>
                    </div>

                    <DataTable ref="transactionSummary" :value="transactionSummary" dataKey="invoiceNumber"
                               :paginator="true"
                               :rows="20"
                               paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                               :rowsPerPageOptions="[10,20,30]"
                               currentPageReportTemplate="Showing {first} to {last} of {totalRecords} transactions"
                               striped-rows
                               responsiveLayout="scroll">

                        <Column field="date" header="Date" :sortable="true">
                            <template #body="slotProps">
                                <span class="p-column-title">Date</span>
                                {{ slotProps.data.date }}
                            </template>
                        </Column>

                        <Column field="type" header="Document Type" :sortable="true">
                            <template #body="slotProps">
                                <span class="p-column-title">Event Type</span>
                                {{ slotProps.data.type }}
                            </template>
                        </Column>

                        <Column field="clientId" header="Client #" :sortable="true">
                            <template #body="slotProps">
                                <span class="p-column-title">Client #</span>
                                {{ slotProps.data.clientId }}
                            </template>
                        </Column>

                        <Column field="clientName" header="Client Name" :sortable="true">
                            <template #body="slotProps">
                                <span class="p-column-title">Client Name</span>
                                {{ slotProps.data.clientName }}
                            </template>
                        </Column>

                        <Column field="invoiceNumber" header="Invoice #" :sortable="true">
                            <template #body="slotProps">
                                <span class="p-column-title">Invoice #</span>
                                {{ slotProps.data.uniqueId }}
                            </template>
                        </Column>

                        <Column field="paymentId" header="Payment #" :sortable="true">
                            <template #body="slotProps">
                                <span class="p-column-title">Payment #</span>
                                {{ slotProps.data.paymentId }}
                            </template>
                        </Column>

                        <Column field="appointmentId" header="Appointment #" :sortable="true">
                            <template #body="slotProps">
                                <span class="p-column-title">Appointment #</span>
                                {{ slotProps.data.appointmentId }}
                            </template>
                        </Column>

                        <Column field="billingPlanName" header="Billing Plan Name" :sortable="true">
                            <template #body="slotProps">
                                <span class="p-column-title">Billing Plan Name</span>
                                {{ slotProps.data.billingPlanName }}
                            </template>
                        </Column>

                        <Column field="amount" header="Amount" :sortable="true">
                            <template #body="slotProps">
                                <span class="p-column-title">Amount</span>
                                {{ formatAmount(slotProps.data.amount) }}
                            </template>
                        </Column>

                    </DataTable>

                    <br>
                    <h3>Total Amount Invoiced</h3>
                    {{ formatTotal(transactionTotals.totalAmountInvoiced) }}

                    <br><br>
                    <h3>Actual Amount Received</h3>
                    {{ formatTotal(transactionTotals.actualAmountReceived) }}

                </div>
            </div>
        </div>


        <div v-show="activeTab === 20" class="grid">
            <div class="col-12 md:col-12">
                <div class="card p-fluid">

                    <h3>Appointment Detail Summary</h3>

                    <div class="field">
                        <label for="startDate">Start Date</label>
                        <Calendar id="startDate" v-model="reportInfo.startDate" required="true"
                                  :showTime="true"
                                  :showSeconds="true" :showIcon="true" dateFormat="yy-mm-dd"/>

                    </div>

                    <div class="field">
                        <label for="endDate">End Date</label>
                        <Calendar id="endDate" v-model="reportInfo.endDate" required="true"
                                  :showTime="true"
                                  :showSeconds="true" :showIcon="true" dateFormat="yy-mm-dd"/>

                    </div>

                    <Button label="View" class="mr-2 mb-2" :loading="submitted"
                            @click="viewFinancialRelatedReport06"></Button>
                    <Button label="Email" class="mr-2 mb-2" :loading="submitted"
                            @click="emailFinancialRelatedReport06"></Button>
                    <Button label="Cancel" class="mr-2 mb-2" :loading="submitted" @click="callReset"></Button>

                </div>
            </div>
        </div>

        <div v-show="activeTab === 21" class="grid">
            <div class="col-12 md:col-12">
                <div class="card p-fluid">

                    <h3>Appointment Detail</h3>

                    <div class="grid">
                        <ul class="list-none p-0 m-0 flex lg:align-items-center flex-column lg:flex-row select-none">
                            <li>
                                <a @click="callReset" v-ripple
                                   class="flex p-3 align-items-center text-600 hover:text-900 hover:surface-100 font-medium border-round cursor-pointer transition-colors transition-duration-150 p-ripple">
                                    <i class="pi pi-plus-circle mr-2"></i>
                                    <span>Back to Reports</span>
                                </a>
                            </li>
                        </ul>
                    </div>

                    <DataTable ref="transactionSummary" :value="transactionSummary" dataKey="appointmentId"
                               :paginator="true"
                               :rows="20"
                               paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                               :rowsPerPageOptions="[10,20,30]"
                               currentPageReportTemplate="Showing {first} to {last} of {totalRecords} appointments"
                               striped-rows
                               responsiveLayout="scroll">

                        <Column field="appointmentId" header="App #" :sortable="true">
                            <template #body="slotProps">
                                <span class="p-column-title">App #</span>
                                {{ slotProps.data.appointmentId }}
                            </template>
                        </Column>

                        <Column field="scheduled" header="App Date" :sortable="true">
                            <template #body="slotProps">
                                <span class="p-column-title">App Date</span>
                                {{ formatDate(slotProps.data.scheduled) }}
                            </template>
                        </Column>

                        <Column field="clientId" header="Client #" :sortable="true">
                            <template #body="slotProps">
                                <span class="p-column-title">Client #</span>
                                {{ slotProps.data.clientId }}
                            </template>
                        </Column>

                        <Column field="clientName" header="Client Name" :sortable="true">
                            <template #body="slotProps">
                                <span class="p-column-title">Client Name</span>
                                {{ slotProps.data.clientName }}
                            </template>
                        </Column>

                        <Column field="uniqueId" header="Invoice #" :sortable="true">
                            <template #body="slotProps">
                                <span class="p-column-title">Invoice #</span>
                                {{ slotProps.data.uniqueId }}
                            </template>
                        </Column>

                        <Column field="invoiced" header="Invoice Date" :sortable="true">
                            <template #body="slotProps">
                                <span class="p-column-title">Invoice Date</span>
                                {{ formatDate(slotProps.data.invoiced) }}
                            </template>
                        </Column>

                        <Column field="invoiceAmount" header="Invoice Amount" :sortable="true">
                            <template #body="slotProps">
                                <span class="p-column-title">Invoice Amount</span>
                                {{ formatAmount(slotProps.data.invoiceAmount) }}
                            </template>
                        </Column>

                        <Column field="paymentId" header="Payment #" :sortable="true">
                            <template #body="slotProps">
                                <span class="p-column-title">Payment #</span>
                                {{ slotProps.data.paymentId }}
                            </template>
                        </Column>

                        <Column field="paid" header="Payment Date" :sortable="true">
                            <template #body="slotProps">
                                <span class="p-column-title">Payment Date</span>
                                {{ formatDate(slotProps.data.paid) }}
                            </template>
                        </Column>

                        <Column field="paidAmount" header="Payment Amount" :sortable="true">
                            <template #body="slotProps">
                                <span class="p-column-title">Payment Amount</span>
                                {{ formatAmount(slotProps.data.paidAmount) }}
                            </template>
                        </Column>

                        <Column field="billingPlanName" header="Billing Plan Name" :sortable="true">
                            <template #body="slotProps">
                                <span class="p-column-title">Billing Plan Name</span>
                                {{ slotProps.data.billingPlanName }}
                            </template>
                        </Column>

                    </DataTable>

                </div>
            </div>
        </div>

    </div>

    <IsoEvolveFooter/>

</template>

<script>
import IsoEvolveFooter from "@/components/heading/authentication/IsoEvolveFooter.vue";
import MenuHealthCompact from "@/components/menu/health/MenuHealthCompact.vue";
import {useUserStore} from "@/stores/UserStore";
import UserService from "@/service/UserService";
import numeral from "numeral";
import DashboardService from "@/service/DashboardService";
import moment from "moment";
import ReportService from "@/service/ReportService";
import {FilterMatchMode, FilterOperator} from "primevue/api";
import ClientService from "@/service/ClientService";
import ProcessService from "@/service/ProcessService";
import CompanyService from "@/service/CompanyService";
import PractitionerService from "@/service/PractitionerService";
import MenuFinancialCompact from "@/components/menu/famodule/MenuFinancialCompact.vue";

export default {
    components: {
        MenuFinancialCompact,
        IsoEvolveFooter, MenuHealthCompact
    },
    setup() {
        const userStore = useUserStore()

        return {
            userStore
        }
    },
    created() {
        this.initFilters1();
        this.initFilters2();
    },
    async mounted() {

        await this.loadCompanyContext();

    },
    data() {

        return {
            profile: {},
            companyConfiguration: {},
            activeTab: 1,
            reportInfo: {},
            tasksPerUser: null,
            financialSummary: {},
            tasksProcessDurationPerUser: null,
            transactionSummary: null,
            tasksPerformancePerUser: {},
            filters1: null,
            filters2: null,
            selectedPractitioner: null,
            filteredProcesses: [],
            filteredClients: [],
            filteredUsers: [],
            practitioners: [],
            loading1: true,
            submitted: false,
        }
    },
    watch: {
        'userStore.activeCompanyId': {
            immediate: false,
            async handler(newCompanyId, oldCompanyId) {
                if (!newCompanyId || newCompanyId === oldCompanyId) {
                    return;
                }
                await this.loadCompanyContext();
            }
        }
    },
    computed: {
        totalTaskDuration() {
            if (!this.tasksPerUser) {
                return 0;
            }

            return this.tasksPerUser.reduce(
                (total, task) => total + (task.taskDuration || 0),
                0
            );
        },
        invoiceTotals() {
            // Total = amount of all invoices in the period; Actual = amount paid against those invoices
            const lines = this.transactionSummary || [];

            return {
                totalAmountInvoiced: lines.reduce((total, invoice) => total + (invoice.amount || 0), 0),
                actualAmountReceived: lines.reduce((total, invoice) => total + (invoice.paid || 0), 0)
            };
        },
        transactionTotals() {
            // Total = sum of the invoice lines; Actual = sum of the payment lines
            const lines = this.transactionSummary || [];

            const sumOfType = type => lines
                .filter(line => line.type === type)
                .reduce((total, line) => total + (line.amount || 0), 0);

            return {
                totalAmountInvoiced: sumOfType('Invoice'),
                actualAmountReceived: sumOfType('Payment')
            };
        }
    },
    methods: {
        async loadCompanyContext() {

            try {
                // Attempt to get user data
                const userData = await UserService.getUser(this.userStore.user.id);
                this.profile = userData.data;
            } catch (e) {
                this.userStore.clearUser();
                this.$router.push('login');
                return;
            }

            this.profile.companyId = this.userStore.activeCompanyId;

            const [companyConfigData] = await Promise.all([
                CompanyService.getCompanyConfiguration(this.profile.companyId)
            ]);

            this.companyConfiguration = companyConfigData.data;

            this.loading1 = false;

            if (this.userStore.user.rights === 'M') {
                this.activeTab = 15;
            } else {
                this.activeTab = 1;
            }
        },
        initFilters1() {
            this.filters1 = {
                'global': {value: null, matchMode: FilterMatchMode.CONTAINS},
                'processName': {
                    operator: FilterOperator.AND,
                    constraints: [{value: null, matchMode: FilterMatchMode.STARTS_WITH}]
                },
                'taskDescription': {
                    operator: FilterOperator.AND,
                    constraints: [{value: null, matchMode: FilterMatchMode.STARTS_WITH}]
                }
            }
        },
        initFilters2() {
            this.filters2 = {
                'global': {value: null, matchMode: FilterMatchMode.CONTAINS},
                'processName': {
                    operator: FilterOperator.AND,
                    constraints: [{value: null, matchMode: FilterMatchMode.STARTS_WITH}]
                },
                'description': {
                    operator: FilterOperator.AND,
                    constraints: [{value: null, matchMode: FilterMatchMode.STARTS_WITH}]
                },
                'username': {
                    operator: FilterOperator.AND,
                    constraints: [{value: null, matchMode: FilterMatchMode.STARTS_WITH}]
                },
                'clientName': {
                    operator: FilterOperator.AND,
                    constraints: [{value: null, matchMode: FilterMatchMode.STARTS_WITH}]
                },
                'end': {
                    operator: FilterOperator.AND,
                    constraints: [{value: null, matchMode: FilterMatchMode.STARTS_WITH}]
                }
            }
        },
        clearFilter1() {
            this.initFilters1();
        },
        clearFilter2() {
            this.initFilters2();
        },
        convertDateIntoUtcTimezone(inputDate) {
            try {
                const moment = require("moment-timezone");

                let inputTimeZone = "Europe/London";

                if (this.companyConfiguration.region == "ZA") {
                    inputTimeZone = "Africa/Johannesburg";
                }

                const targetTimeZone = "Etc/UTC"; // Assuming the input date is in UTC

                // Parse the input date string and set the input time zone
                const parsedDate = moment.tz(inputDate, "YYYY-MM-DD HH:mm:ss", inputTimeZone);

                // Convert the date to the target time zone
                const outputDate = parsedDate.clone().tz(targetTimeZone);

                return outputDate.format("YYYY-MM-DD HH:mm:ss");

            } catch (error) {
                return inputDate;
            }

        },
        convertDateIntoLocalTimezone(inputDate) {
            try {
                const moment = require("moment-timezone");
                const inputTimeZone = "Etc/UTC"; // Assuming the input date is in UTC

                let targetTimeZone = "Europe/London";

                if (this.companyConfiguration.region == "ZA") {
                    targetTimeZone = "Africa/Johannesburg";
                }

                // Parse the input date string and set the input time zone
                const parsedDate = moment.tz(inputDate, "YYYY-MM-DD HH:mm:ss", inputTimeZone);

                // Convert the date to the target time zone
                const outputDate = parsedDate.clone().tz(targetTimeZone);

                return outputDate.format("YYYY-MM-DD HH:mm:ss");

            } catch (error) {
                return inputDate;
            }

        },
        calculateTimeDifference(startTime) {
            // Parse the target date string into a Date object
            const targetDate = new Date(startTime);

            // Get the current date and time
            const currentDate = new Date();

            // Calculate the time difference in milliseconds
            const timeDifferenceMs = currentDate - targetDate;

            return timeDifferenceMs / 1000;
        },
        formatTime(seconds) {
            const days = Math.floor(seconds / (3600 * 24));
            seconds -= days * 3600 * 24;

            const hours = Math.floor(seconds / 3600);
            seconds -= hours * 3600;

            const minutes = Math.floor(seconds / 60);
            seconds -= minutes * 60;

            const formattedSeconds = seconds.toFixed(2);

            let formattedTime = "";

            if (days > 0) {
                formattedTime += `${days} day${days > 1 ? 's' : ''} `;
            }

            if (hours > 0) {
                formattedTime += `${hours} hr${hours > 1 ? 's' : ''} `;
            }

            if (minutes > 0) {
                formattedTime += `${minutes} min${minutes > 1 ? 's' : ''} `;
            }

            if (seconds > 0 || formattedTime === "") {
                formattedTime += `${formattedSeconds} sec${formattedSeconds !== 1 ? 's' : ''}`;
            }

            return formattedTime;
        },
        formatTimeInHours(seconds) {
            const hours = Math.floor(seconds / 3600);
            seconds -= hours * 3600;

            const minutes = Math.floor(seconds / 60);
            seconds -= minutes * 60;

            const formattedSeconds = seconds.toFixed(2);

            let formattedTime = "";

            if (hours > 0) {
                formattedTime += `${hours} hr${hours > 1 ? 's' : ''} `;
            }

            if (minutes > 0) {
                formattedTime += `${minutes} min${minutes > 1 ? 's' : ''} `;
            }

            if (seconds > 0 || formattedTime === "") {
                formattedTime += `${formattedSeconds} sec${formattedSeconds !== 1 ? 's' : ''}`;
            }

            return formattedTime;
        },
        formatDate(inputDate) {

            if (!inputDate) {
                return '';
            }

            const localDate = this.convertDateIntoLocalTimezone(inputDate);
            const date = new Date(localDate);

            // Check for invalid date
            if (isNaN(date.getTime())) {
                console.error('Invalid date:', inputDate, localDate);
                return '';
            }

            const year = date.getFullYear();
            const month = String(date.getMonth() + 1).padStart(2, '0');
            const day = String(date.getDate()).padStart(2, '0');

            const hours = String(date.getHours()).padStart(2, '0');
            const minutes = String(date.getMinutes()).padStart(2, '0');
            const seconds = String(date.getSeconds()).padStart(2, '0');

            return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
        },
        formatAmount(value) {
            if (value) {
                return numeral(String(value)).format('0,0.00');
            } else {
                return '';
            }
        },
        formatTotal(value) {
            return numeral(value || 0).format('0,0.00');
        },
        callReset() {
            if (this.userStore.user.rights === 'M') {
                this.activeTab = 15;
            } else {
                this.activeTab = 1;
            }
        },
        searchProcesses(event) {
            ProcessService.searchCompanyProcesses(this.profile.companyId, event.query.toLowerCase())
                .then(data => {
                    this.filteredProcesses = data.data;
                });
        },
        searchUsers() {
            UserService.getCompanyUsers(this.profile.companyId)
                .then(data => {
                    this.filteredUsers = data.data;
                });

        },
        searchClients(event) {
            ClientService.searchCompanyClients(this.profile.companyId, event.query.toLowerCase())
                .then(data => {
                    this.filteredClients = data.data;
                });
        },
        callTaskRelatedReport01() {
            const currentDate = moment();
            const previousDate = currentDate.clone().subtract(1, 'days');

            this.reportInfo.startDate = previousDate.format('YYYY-MM-DD HH:mm:ss');

            this.reportInfo.endDate = currentDate.format('YYYY-MM-DD HH:mm:ss');

            this.reportInfo.user = null;

            this.activeTab = 2;
        },
        callTaskRelatedReport02() {
            const currentDate = moment();
            const previousDate = currentDate.clone().subtract(1, 'days');

            this.reportInfo.startDate = previousDate.format('YYYY-MM-DD HH:mm:ss');

            this.reportInfo.endDate = currentDate.format('YYYY-MM-DD HH:mm:ss');

            this.reportInfo.user = null;

            this.activeTab = 5;
        },
        callTaskRelatedReport03() {
            const currentDate = moment();
            const previousDate = currentDate.clone().subtract(1, 'days');

            this.reportInfo.startDate = previousDate.format('YYYY-MM-DD HH:mm:ss');

            this.reportInfo.endDate = currentDate.format('YYYY-MM-DD HH:mm:ss');

            this.reportInfo.user = null;

            this.activeTab = 7;
        },
        callFinancialRelatedReport01() {
            const currentDate = moment();
            const previousDate = currentDate.clone().subtract(30, 'days');

            this.reportInfo.startDate = previousDate.format('YYYY-MM-DD HH:mm:ss');

            this.reportInfo.endDate = currentDate.format('YYYY-MM-DD HH:mm:ss');

            this.reportInfo.user = null;

            this.activeTab = 9;
        },
        callFinancialRelatedReport02() {
            const currentDate = moment();
            const previousDate = currentDate.clone().subtract(30, 'days');

            this.reportInfo.startDate = previousDate.format('YYYY-MM-DD HH:mm:ss');

            this.reportInfo.endDate = currentDate.format('YYYY-MM-DD HH:mm:ss');

            this.reportInfo.user = null;

            this.activeTab = 11;
        },
        async callFinancialRelatedReport03() {
            const currentDate = moment();
            const previousDate = currentDate.clone().subtract(30, 'days');

            this.reportInfo.startDate = previousDate.format('YYYY-MM-DD HH:mm:ss');

            this.reportInfo.endDate = currentDate.format('YYYY-MM-DD HH:mm:ss');

            this.reportInfo.user = null;

            const [practitioners] = await Promise.all([
                PractitionerService.getCompanyPractitioners(this.profile.companyId),
            ]);

            this.practitioners = practitioners.data;

            if ((this.practitioners.length > 0) && (this.selectedPractitioner === null)) {
                this.selectedPractitioner = this.practitioners[0].id;
            }

            this.activeTab = 13;
        },
        callFinancialRelatedReport04() {
            const currentDate = moment();
            const previousDate = currentDate.clone().subtract(30, 'days');

            this.reportInfo.startDate = previousDate.format('YYYY-MM-DD HH:mm:ss');

            this.reportInfo.endDate = currentDate.format('YYYY-MM-DD HH:mm:ss');

            this.reportInfo.user = null;

            this.activeTab = 16;
        },
        callFinancialRelatedReport05() {
            const currentDate = moment();
            const previousDate = currentDate.clone().subtract(30, 'days');

            this.reportInfo.startDate = previousDate.format('YYYY-MM-DD HH:mm:ss');

            this.reportInfo.endDate = currentDate.format('YYYY-MM-DD HH:mm:ss');

            this.reportInfo.user = null;

            this.activeTab = 18;
        },
        callFinancialRelatedReport06() {
            const currentDate = moment();
            const previousDate = currentDate.clone().subtract(30, 'days');

            this.reportInfo.startDate = previousDate.format('YYYY-MM-DD HH:mm:ss');

            this.reportInfo.endDate = currentDate.format('YYYY-MM-DD HH:mm:ss');

            this.reportInfo.user = null;

            this.activeTab = 20;
        },
        async callUserFinancialRelatedReport01() {
            const currentDate = moment();
            const previousDate = currentDate.clone().subtract(30, 'days');

            this.reportInfo.startDate = previousDate.format('YYYY-MM-DD HH:mm:ss');

            this.reportInfo.endDate = currentDate.format('YYYY-MM-DD HH:mm:ss');

            this.reportInfo.user = null;

            const [practitioners] = await Promise.all([
                PractitionerService.getCompanyPractitioners(this.profile.companyId),
            ]);

            this.practitioners = practitioners.data.filter(
                (p) => p.email === this.profile.email
            );

            if ((this.practitioners.length > 0) && (this.selectedPractitioner === null)) {
                this.selectedPractitioner = this.practitioners[0].id;
            }

            this.activeTab = 13;
        },
        async viewTaskRelatedReport01() {
            var tempUser = "";
            try {
                tempUser = this.reportInfo.user.id;
            } catch (error) {
                tempUser = "";
            }

            const startDateInput = new Date(this.convertDateIntoUtcTimezone(this.reportInfo.startDate));
            const yearStart = startDateInput.getFullYear();
            const monthStart = String(startDateInput.getMonth() + 1).padStart(2, '0');
            const dayStart = String(startDateInput.getDate()).padStart(2, '0');
            const hoursStart = String(startDateInput.getHours()).padStart(2, '0');
            const minutesStart = String(startDateInput.getMinutes()).padStart(2, '0');
            const secondsStart = String(startDateInput.getSeconds()).padStart(2, '0');

            const startDate = `${yearStart}-${monthStart}-${dayStart} ${hoursStart}:${minutesStart}:${secondsStart}`;

            const endDateInput = new Date(this.convertDateIntoUtcTimezone(this.reportInfo.endDate));
            const yearEnd = endDateInput.getFullYear();
            const monthEnd = String(endDateInput.getMonth() + 1).padStart(2, '0');
            const dayEnd = String(endDateInput.getDate()).padStart(2, '0');
            const hoursEnd = String(endDateInput.getHours()).padStart(2, '0');
            const minutesEnd = String(endDateInput.getMinutes()).padStart(2, '0');
            const secondsEnd = String(endDateInput.getSeconds()).padStart(2, '0');

            const endDate = `${yearEnd}-${monthEnd}-${dayEnd} ${hoursEnd}:${minutesEnd}:${secondsEnd}`;

            const [taskData] = await Promise.all([
                DashboardService.getTasksForUser(tempUser, startDate, endDate)
            ]);

            this.tasksPerUser = taskData.data;

            this.loading1 = false;

            this.activeTab = 3;
        },
        async viewTaskRelatedReport02() {
            var tempUser = "";
            try {
                tempUser = this.reportInfo.user.id;
            } catch (error) {
                tempUser = "";
            }

            const startDateInput = new Date(this.convertDateIntoUtcTimezone(this.reportInfo.startDate));
            const yearStart = startDateInput.getFullYear();
            const monthStart = String(startDateInput.getMonth() + 1).padStart(2, '0');
            const dayStart = String(startDateInput.getDate()).padStart(2, '0');
            const hoursStart = String(startDateInput.getHours()).padStart(2, '0');
            const minutesStart = String(startDateInput.getMinutes()).padStart(2, '0');
            const secondsStart = String(startDateInput.getSeconds()).padStart(2, '0');

            const startDate = `${yearStart}-${monthStart}-${dayStart} ${hoursStart}:${minutesStart}:${secondsStart}`;

            const endDateInput = new Date(this.convertDateIntoUtcTimezone(this.reportInfo.endDate));
            const yearEnd = endDateInput.getFullYear();
            const monthEnd = String(endDateInput.getMonth() + 1).padStart(2, '0');
            const dayEnd = String(endDateInput.getDate()).padStart(2, '0');
            const hoursEnd = String(endDateInput.getHours()).padStart(2, '0');
            const minutesEnd = String(endDateInput.getMinutes()).padStart(2, '0');
            const secondsEnd = String(endDateInput.getSeconds()).padStart(2, '0');

            const endDate = `${yearEnd}-${monthEnd}-${dayEnd} ${hoursEnd}:${minutesEnd}:${secondsEnd}`;

            const [taskData] = await Promise.all([
                DashboardService.getProcessDurationForUser(tempUser, startDate, endDate)
            ]);

            this.tasksProcessDurationPerUser = taskData.data;

            this.loading1 = false;

            this.activeTab = 6;
        },
        async viewTaskRelatedReport03() {
            var tempUser = "";
            try {
                tempUser = this.reportInfo.user.id;
            } catch (error) {
                tempUser = "";
            }

            const startDateInput = new Date(this.convertDateIntoUtcTimezone(this.reportInfo.startDate));
            const yearStart = startDateInput.getFullYear();
            const monthStart = String(startDateInput.getMonth() + 1).padStart(2, '0');
            const dayStart = String(startDateInput.getDate()).padStart(2, '0');
            const hoursStart = String(startDateInput.getHours()).padStart(2, '0');
            const minutesStart = String(startDateInput.getMinutes()).padStart(2, '0');
            const secondsStart = String(startDateInput.getSeconds()).padStart(2, '0');

            const startDate = `${yearStart}-${monthStart}-${dayStart} ${hoursStart}:${minutesStart}:${secondsStart}`;

            const endDateInput = new Date(this.convertDateIntoUtcTimezone(this.reportInfo.endDate));
            const yearEnd = endDateInput.getFullYear();
            const monthEnd = String(endDateInput.getMonth() + 1).padStart(2, '0');
            const dayEnd = String(endDateInput.getDate()).padStart(2, '0');
            const hoursEnd = String(endDateInput.getHours()).padStart(2, '0');
            const minutesEnd = String(endDateInput.getMinutes()).padStart(2, '0');
            const secondsEnd = String(endDateInput.getSeconds()).padStart(2, '0');

            const endDate = `${yearEnd}-${monthEnd}-${dayEnd} ${hoursEnd}:${minutesEnd}:${secondsEnd}`;

            const [taskData] = await Promise.all([
                DashboardService.getTaskPerformanceForUser(tempUser, startDate, endDate)
            ]);

            this.tasksPerformancePerUser = taskData.data;

            this.loading1 = false;

            this.activeTab = 8;
        },
        async viewFinancialRelatedReport01() {
            const startDateInput = new Date(this.convertDateIntoUtcTimezone(this.reportInfo.startDate));
            const yearStart = startDateInput.getFullYear();
            const monthStart = String(startDateInput.getMonth() + 1).padStart(2, '0');
            const dayStart = String(startDateInput.getDate()).padStart(2, '0');
            const hoursStart = String(startDateInput.getHours()).padStart(2, '0');
            const minutesStart = String(startDateInput.getMinutes()).padStart(2, '0');
            const secondsStart = String(startDateInput.getSeconds()).padStart(2, '0');

            const startDate = `${yearStart}-${monthStart}-${dayStart} ${hoursStart}:${minutesStart}:${secondsStart}`;

            const endDateInput = new Date(this.convertDateIntoUtcTimezone(this.reportInfo.endDate));
            const yearEnd = endDateInput.getFullYear();
            const monthEnd = String(endDateInput.getMonth() + 1).padStart(2, '0');
            const dayEnd = String(endDateInput.getDate()).padStart(2, '0');
            const hoursEnd = String(endDateInput.getHours()).padStart(2, '0');
            const minutesEnd = String(endDateInput.getMinutes()).padStart(2, '0');
            const secondsEnd = String(endDateInput.getSeconds()).padStart(2, '0');

            const endDate = `${yearEnd}-${monthEnd}-${dayEnd} ${hoursEnd}:${minutesEnd}:${secondsEnd}`;

            const [taskData] = await Promise.all([
                DashboardService.getFinancialSummaryForCompany(this.profile.companyId, startDate, endDate)
            ]);

            this.financialSummary = taskData.data;

            this.loading1 = false;

            this.activeTab = 10;
        },
        async emailFinancialRelatedReport01() {
            const startDateInput = new Date(this.convertDateIntoUtcTimezone(this.reportInfo.startDate));
            const yearStart = startDateInput.getFullYear();
            const monthStart = String(startDateInput.getMonth() + 1).padStart(2, '0');
            const dayStart = String(startDateInput.getDate()).padStart(2, '0');
            const hoursStart = String(startDateInput.getHours()).padStart(2, '0');
            const minutesStart = String(startDateInput.getMinutes()).padStart(2, '0');
            const secondsStart = String(startDateInput.getSeconds()).padStart(2, '0');

            const startDate = `${yearStart}-${monthStart}-${dayStart} ${hoursStart}:${minutesStart}:${secondsStart}`;

            const endDateInput = new Date(this.convertDateIntoUtcTimezone(this.reportInfo.endDate));
            const yearEnd = endDateInput.getFullYear();
            const monthEnd = String(endDateInput.getMonth() + 1).padStart(2, '0');
            const dayEnd = String(endDateInput.getDate()).padStart(2, '0');
            const hoursEnd = String(endDateInput.getHours()).padStart(2, '0');
            const minutesEnd = String(endDateInput.getMinutes()).padStart(2, '0');
            const secondsEnd = String(endDateInput.getSeconds()).padStart(2, '0');

            const endDate = `${yearEnd}-${monthEnd}-${dayEnd} ${hoursEnd}:${minutesEnd}:${secondsEnd}`;

            try {
                await Promise.all([
                    ReportService.getFinancialSummary(this.profile.companyId, startDate, endDate)
                ]);

                this.$toast.add({
                    severity: 'success', summary: 'Successful', detail: 'Report Emailed', life: 3000
                });

            } catch (e) {
                this.$toast.add({
                    severity: 'error',
                    summary: 'Unsuccessful',
                    detail: 'Report NOT Emailed',
                    life: 3000
                });
            }

            this.activeTab = 1;
        },
        async viewFinancialRelatedReport02() {
            this.submitted = true;

            const startDateInput = new Date(this.convertDateIntoUtcTimezone(this.reportInfo.startDate));
            const yearStart = startDateInput.getFullYear();
            const monthStart = String(startDateInput.getMonth() + 1).padStart(2, '0');
            const dayStart = String(startDateInput.getDate()).padStart(2, '0');
            const hoursStart = String(startDateInput.getHours()).padStart(2, '0');
            const minutesStart = String(startDateInput.getMinutes()).padStart(2, '0');
            const secondsStart = String(startDateInput.getSeconds()).padStart(2, '0');

            const startDate = `${yearStart}-${monthStart}-${dayStart} ${hoursStart}:${minutesStart}:${secondsStart}`;

            const endDateInput = new Date(this.convertDateIntoUtcTimezone(this.reportInfo.endDate));
            const yearEnd = endDateInput.getFullYear();
            const monthEnd = String(endDateInput.getMonth() + 1).padStart(2, '0');
            const dayEnd = String(endDateInput.getDate()).padStart(2, '0');
            const hoursEnd = String(endDateInput.getHours()).padStart(2, '0');
            const minutesEnd = String(endDateInput.getMinutes()).padStart(2, '0');
            const secondsEnd = String(endDateInput.getSeconds()).padStart(2, '0');

            const endDate = `${yearEnd}-${monthEnd}-${dayEnd} ${hoursEnd}:${minutesEnd}:${secondsEnd}`;

            const [taskData] = await Promise.all([
                DashboardService.getTransactionSummaryForCompany(this.profile.companyId, startDate, endDate)
            ]);

            this.transactionSummary = taskData.data.financialTransactionDtoList;

            this.loading1 = false;
            this.submitted = false;

            this.activeTab = 12;
            this.submitted = false;
        },
        async emailFinancialRelatedReport02() {
            this.submitted = true;

            const startDateInput = new Date(this.convertDateIntoUtcTimezone(this.reportInfo.startDate));
            const yearStart = startDateInput.getFullYear();
            const monthStart = String(startDateInput.getMonth() + 1).padStart(2, '0');
            const dayStart = String(startDateInput.getDate()).padStart(2, '0');
            const hoursStart = String(startDateInput.getHours()).padStart(2, '0');
            const minutesStart = String(startDateInput.getMinutes()).padStart(2, '0');
            const secondsStart = String(startDateInput.getSeconds()).padStart(2, '0');

            const startDate = `${yearStart}-${monthStart}-${dayStart} ${hoursStart}:${minutesStart}:${secondsStart}`;

            const endDateInput = new Date(this.convertDateIntoUtcTimezone(this.reportInfo.endDate));
            const yearEnd = endDateInput.getFullYear();
            const monthEnd = String(endDateInput.getMonth() + 1).padStart(2, '0');
            const dayEnd = String(endDateInput.getDate()).padStart(2, '0');
            const hoursEnd = String(endDateInput.getHours()).padStart(2, '0');
            const minutesEnd = String(endDateInput.getMinutes()).padStart(2, '0');
            const secondsEnd = String(endDateInput.getSeconds()).padStart(2, '0');

            const endDate = `${yearEnd}-${monthEnd}-${dayEnd} ${hoursEnd}:${minutesEnd}:${secondsEnd}`;

            try {
                await Promise.all([
                    ReportService.getTransactionSummary(this.profile.companyId, startDate, endDate)
                ]);

                this.$toast.add({
                    severity: 'success', summary: 'Successful', detail: 'Report Emailed', life: 3000
                });

                this.submitted = false;

            } catch (e) {
                this.$toast.add({
                    severity: 'error',
                    summary: 'Unsuccessful',
                    detail: 'Report NOT Emailed',
                    life: 3000
                });
            }

            this.activeTab = 1;
            this.submitted = false;
        },
        async viewFinancialRelatedReport03() {
            this.submitted = true;

            const startDateInput = new Date(this.convertDateIntoUtcTimezone(this.reportInfo.startDate));
            const yearStart = startDateInput.getFullYear();
            const monthStart = String(startDateInput.getMonth() + 1).padStart(2, '0');
            const dayStart = String(startDateInput.getDate()).padStart(2, '0');
            const hoursStart = String(startDateInput.getHours()).padStart(2, '0');
            const minutesStart = String(startDateInput.getMinutes()).padStart(2, '0');
            const secondsStart = String(startDateInput.getSeconds()).padStart(2, '0');

            const startDate = `${yearStart}-${monthStart}-${dayStart} ${hoursStart}:${minutesStart}:${secondsStart}`;

            const endDateInput = new Date(this.convertDateIntoUtcTimezone(this.reportInfo.endDate));
            const yearEnd = endDateInput.getFullYear();
            const monthEnd = String(endDateInput.getMonth() + 1).padStart(2, '0');
            const dayEnd = String(endDateInput.getDate()).padStart(2, '0');
            const hoursEnd = String(endDateInput.getHours()).padStart(2, '0');
            const minutesEnd = String(endDateInput.getMinutes()).padStart(2, '0');
            const secondsEnd = String(endDateInput.getSeconds()).padStart(2, '0');

            const endDate = `${yearEnd}-${monthEnd}-${dayEnd} ${hoursEnd}:${minutesEnd}:${secondsEnd}`;

            const [taskData] = await Promise.all([
                DashboardService.getPractitionerTransactionSummaryForCompany(
                    this.profile.companyId, startDate, endDate, this.selectedPractitioner)
            ]);

            this.transactionSummary = taskData.data.financialTransactionDtoList;

            this.loading1 = false;
            this.submitted = false;

            this.activeTab = 14;
            this.submitted = false;
        },
        async emailFinancialRelatedReport03() {
            this.submitted = true;

            const startDateInput = new Date(this.convertDateIntoUtcTimezone(this.reportInfo.startDate));
            const yearStart = startDateInput.getFullYear();
            const monthStart = String(startDateInput.getMonth() + 1).padStart(2, '0');
            const dayStart = String(startDateInput.getDate()).padStart(2, '0');
            const hoursStart = String(startDateInput.getHours()).padStart(2, '0');
            const minutesStart = String(startDateInput.getMinutes()).padStart(2, '0');
            const secondsStart = String(startDateInput.getSeconds()).padStart(2, '0');

            const startDate = `${yearStart}-${monthStart}-${dayStart} ${hoursStart}:${minutesStart}:${secondsStart}`;

            const endDateInput = new Date(this.convertDateIntoUtcTimezone(this.reportInfo.endDate));
            const yearEnd = endDateInput.getFullYear();
            const monthEnd = String(endDateInput.getMonth() + 1).padStart(2, '0');
            const dayEnd = String(endDateInput.getDate()).padStart(2, '0');
            const hoursEnd = String(endDateInput.getHours()).padStart(2, '0');
            const minutesEnd = String(endDateInput.getMinutes()).padStart(2, '0');
            const secondsEnd = String(endDateInput.getSeconds()).padStart(2, '0');

            const endDate = `${yearEnd}-${monthEnd}-${dayEnd} ${hoursEnd}:${minutesEnd}:${secondsEnd}`;

            try {
                await Promise.all([
                    ReportService.getPractitionerTransactionSummary(
                        this.profile.companyId, startDate, endDate, this.selectedPractitioner)
                ]);

                this.$toast.add({
                    severity: 'success', summary: 'Successful', detail: 'Report Emailed', life: 3000
                });

                this.submitted = false;

            } catch (e) {
                this.$toast.add({
                    severity: 'error',
                    summary: 'Unsuccessful',
                    detail: 'Report NOT Emailed',
                    life: 3000
                });
            }

            this.activeTab = 1;
            this.submitted = false;
        },
        async viewFinancialRelatedReport04() {
            this.submitted = true;

            const startDateInput = new Date(this.convertDateIntoUtcTimezone(this.reportInfo.startDate));
            const yearStart = startDateInput.getFullYear();
            const monthStart = String(startDateInput.getMonth() + 1).padStart(2, '0');
            const dayStart = String(startDateInput.getDate()).padStart(2, '0');
            const hoursStart = String(startDateInput.getHours()).padStart(2, '0');
            const minutesStart = String(startDateInput.getMinutes()).padStart(2, '0');
            const secondsStart = String(startDateInput.getSeconds()).padStart(2, '0');

            const startDate = `${yearStart}-${monthStart}-${dayStart} ${hoursStart}:${minutesStart}:${secondsStart}`;

            const endDateInput = new Date(this.convertDateIntoUtcTimezone(this.reportInfo.endDate));
            const yearEnd = endDateInput.getFullYear();
            const monthEnd = String(endDateInput.getMonth() + 1).padStart(2, '0');
            const dayEnd = String(endDateInput.getDate()).padStart(2, '0');
            const hoursEnd = String(endDateInput.getHours()).padStart(2, '0');
            const minutesEnd = String(endDateInput.getMinutes()).padStart(2, '0');
            const secondsEnd = String(endDateInput.getSeconds()).padStart(2, '0');

            const endDate = `${yearEnd}-${monthEnd}-${dayEnd} ${hoursEnd}:${minutesEnd}:${secondsEnd}`;

            const [taskData] = await Promise.all([
                DashboardService.getDetailedTransactionSummaryForCompany(this.profile.companyId, startDate, endDate)
            ]);

            this.transactionSummary = taskData.data;

            this.loading1 = false;
            this.submitted = false;

            this.activeTab = 17;
            this.submitted = false;
        },
        async emailFinancialRelatedReport04() {
            this.submitted = true;

            const startDateInput = new Date(this.convertDateIntoUtcTimezone(this.reportInfo.startDate));
            const yearStart = startDateInput.getFullYear();
            const monthStart = String(startDateInput.getMonth() + 1).padStart(2, '0');
            const dayStart = String(startDateInput.getDate()).padStart(2, '0');
            const hoursStart = String(startDateInput.getHours()).padStart(2, '0');
            const minutesStart = String(startDateInput.getMinutes()).padStart(2, '0');
            const secondsStart = String(startDateInput.getSeconds()).padStart(2, '0');

            const startDate = `${yearStart}-${monthStart}-${dayStart} ${hoursStart}:${minutesStart}:${secondsStart}`;

            const endDateInput = new Date(this.convertDateIntoUtcTimezone(this.reportInfo.endDate));
            const yearEnd = endDateInput.getFullYear();
            const monthEnd = String(endDateInput.getMonth() + 1).padStart(2, '0');
            const dayEnd = String(endDateInput.getDate()).padStart(2, '0');
            const hoursEnd = String(endDateInput.getHours()).padStart(2, '0');
            const minutesEnd = String(endDateInput.getMinutes()).padStart(2, '0');
            const secondsEnd = String(endDateInput.getSeconds()).padStart(2, '0');

            const endDate = `${yearEnd}-${monthEnd}-${dayEnd} ${hoursEnd}:${minutesEnd}:${secondsEnd}`;

            try {
                await Promise.all([
                    ReportService.getDetailedTransactionSummary(this.profile.companyId, startDate, endDate)
                ]);

                this.$toast.add({
                    severity: 'success', summary: 'Successful', detail: 'Report Emailed', life: 3000
                });

                this.submitted = false;

            } catch (e) {
                this.$toast.add({
                    severity: 'error',
                    summary: 'Unsuccessful',
                    detail: 'Report NOT Emailed',
                    life: 3000
                });
            }

            this.activeTab = 1;
            this.submitted = false;
        },
        async viewFinancialRelatedReport05() {
            this.submitted = true;

            const startDateInput = new Date(this.convertDateIntoUtcTimezone(this.reportInfo.startDate));
            const yearStart = startDateInput.getFullYear();
            const monthStart = String(startDateInput.getMonth() + 1).padStart(2, '0');
            const dayStart = String(startDateInput.getDate()).padStart(2, '0');
            const hoursStart = String(startDateInput.getHours()).padStart(2, '0');
            const minutesStart = String(startDateInput.getMinutes()).padStart(2, '0');
            const secondsStart = String(startDateInput.getSeconds()).padStart(2, '0');

            const startDate = `${yearStart}-${monthStart}-${dayStart} ${hoursStart}:${minutesStart}:${secondsStart}`;

            const endDateInput = new Date(this.convertDateIntoUtcTimezone(this.reportInfo.endDate));
            const yearEnd = endDateInput.getFullYear();
            const monthEnd = String(endDateInput.getMonth() + 1).padStart(2, '0');
            const dayEnd = String(endDateInput.getDate()).padStart(2, '0');
            const hoursEnd = String(endDateInput.getHours()).padStart(2, '0');
            const minutesEnd = String(endDateInput.getMinutes()).padStart(2, '0');
            const secondsEnd = String(endDateInput.getSeconds()).padStart(2, '0');

            const endDate = `${yearEnd}-${monthEnd}-${dayEnd} ${hoursEnd}:${minutesEnd}:${secondsEnd}`;

            const [taskData] = await Promise.all([
                DashboardService.getAppInvPaySummaryForCompany(this.profile.companyId, startDate, endDate)
            ]);

            this.transactionSummary = taskData.data;

            this.loading1 = false;
            this.submitted = false;

            this.activeTab = 19;
            this.submitted = false;
        },
        async emailFinancialRelatedReport05() {
            this.submitted = true;

            const startDateInput = new Date(this.convertDateIntoUtcTimezone(this.reportInfo.startDate));
            const yearStart = startDateInput.getFullYear();
            const monthStart = String(startDateInput.getMonth() + 1).padStart(2, '0');
            const dayStart = String(startDateInput.getDate()).padStart(2, '0');
            const hoursStart = String(startDateInput.getHours()).padStart(2, '0');
            const minutesStart = String(startDateInput.getMinutes()).padStart(2, '0');
            const secondsStart = String(startDateInput.getSeconds()).padStart(2, '0');

            const startDate = `${yearStart}-${monthStart}-${dayStart} ${hoursStart}:${minutesStart}:${secondsStart}`;

            const endDateInput = new Date(this.convertDateIntoUtcTimezone(this.reportInfo.endDate));
            const yearEnd = endDateInput.getFullYear();
            const monthEnd = String(endDateInput.getMonth() + 1).padStart(2, '0');
            const dayEnd = String(endDateInput.getDate()).padStart(2, '0');
            const hoursEnd = String(endDateInput.getHours()).padStart(2, '0');
            const minutesEnd = String(endDateInput.getMinutes()).padStart(2, '0');
            const secondsEnd = String(endDateInput.getSeconds()).padStart(2, '0');

            const endDate = `${yearEnd}-${monthEnd}-${dayEnd} ${hoursEnd}:${minutesEnd}:${secondsEnd}`;

            try {
                await Promise.all([
                    ReportService.getAppInvPaySummary(this.profile.companyId, startDate, endDate)
                ]);

                this.$toast.add({
                    severity: 'success', summary: 'Successful', detail: 'Report Emailed', life: 3000
                });

                this.submitted = false;

            } catch (e) {
                this.$toast.add({
                    severity: 'error',
                    summary: 'Unsuccessful',
                    detail: 'Report NOT Emailed',
                    life: 3000
                });
            }

            this.activeTab = 1;
            this.submitted = false;
        },
        async viewFinancialRelatedReport06() {
            this.submitted = true;

            const startDateInput = new Date(this.convertDateIntoUtcTimezone(this.reportInfo.startDate));
            const yearStart = startDateInput.getFullYear();
            const monthStart = String(startDateInput.getMonth() + 1).padStart(2, '0');
            const dayStart = String(startDateInput.getDate()).padStart(2, '0');
            const hoursStart = String(startDateInput.getHours()).padStart(2, '0');
            const minutesStart = String(startDateInput.getMinutes()).padStart(2, '0');
            const secondsStart = String(startDateInput.getSeconds()).padStart(2, '0');

            const startDate = `${yearStart}-${monthStart}-${dayStart} ${hoursStart}:${minutesStart}:${secondsStart}`;

            const endDateInput = new Date(this.convertDateIntoUtcTimezone(this.reportInfo.endDate));
            const yearEnd = endDateInput.getFullYear();
            const monthEnd = String(endDateInput.getMonth() + 1).padStart(2, '0');
            const dayEnd = String(endDateInput.getDate()).padStart(2, '0');
            const hoursEnd = String(endDateInput.getHours()).padStart(2, '0');
            const minutesEnd = String(endDateInput.getMinutes()).padStart(2, '0');
            const secondsEnd = String(endDateInput.getSeconds()).padStart(2, '0');

            const endDate = `${yearEnd}-${monthEnd}-${dayEnd} ${hoursEnd}:${minutesEnd}:${secondsEnd}`;

            const [taskData] = await Promise.all([
                DashboardService.getAppDetailForCompany(this.profile.companyId, startDate, endDate)
            ]);

            this.transactionSummary = taskData.data;

            this.loading1 = false;
            this.submitted = false;

            this.activeTab = 21;
            this.submitted = false;
        },
        async emailFinancialRelatedReport06() {
            this.submitted = true;

            const startDateInput = new Date(this.convertDateIntoUtcTimezone(this.reportInfo.startDate));
            const yearStart = startDateInput.getFullYear();
            const monthStart = String(startDateInput.getMonth() + 1).padStart(2, '0');
            const dayStart = String(startDateInput.getDate()).padStart(2, '0');
            const hoursStart = String(startDateInput.getHours()).padStart(2, '0');
            const minutesStart = String(startDateInput.getMinutes()).padStart(2, '0');
            const secondsStart = String(startDateInput.getSeconds()).padStart(2, '0');

            const startDate = `${yearStart}-${monthStart}-${dayStart} ${hoursStart}:${minutesStart}:${secondsStart}`;

            const endDateInput = new Date(this.convertDateIntoUtcTimezone(this.reportInfo.endDate));
            const yearEnd = endDateInput.getFullYear();
            const monthEnd = String(endDateInput.getMonth() + 1).padStart(2, '0');
            const dayEnd = String(endDateInput.getDate()).padStart(2, '0');
            const hoursEnd = String(endDateInput.getHours()).padStart(2, '0');
            const minutesEnd = String(endDateInput.getMinutes()).padStart(2, '0');
            const secondsEnd = String(endDateInput.getSeconds()).padStart(2, '0');

            const endDate = `${yearEnd}-${monthEnd}-${dayEnd} ${hoursEnd}:${minutesEnd}:${secondsEnd}`;

            try {
                await Promise.all([
                    ReportService.getAppDetailForCompany(this.profile.companyId, startDate, endDate)
                ]);

                this.$toast.add({
                    severity: 'success', summary: 'Successful', detail: 'Report Emailed', life: 3000
                });

                this.submitted = false;

            } catch (e) {
                this.$toast.add({
                    severity: 'error',
                    summary: 'Unsuccessful',
                    detail: 'Report NOT Emailed',
                    life: 3000
                });
            }

            this.activeTab = 1;
            this.submitted = false;
        },
        async viewUserFinancialRelatedReport01() {
            this.submitted = true;

            const startDateInput = new Date(this.convertDateIntoUtcTimezone(this.reportInfo.startDate));
            const yearStart = startDateInput.getFullYear();
            const monthStart = String(startDateInput.getMonth() + 1).padStart(2, '0');
            const dayStart = String(startDateInput.getDate()).padStart(2, '0');
            const hoursStart = String(startDateInput.getHours()).padStart(2, '0');
            const minutesStart = String(startDateInput.getMinutes()).padStart(2, '0');
            const secondsStart = String(startDateInput.getSeconds()).padStart(2, '0');

            const startDate = `${yearStart}-${monthStart}-${dayStart} ${hoursStart}:${minutesStart}:${secondsStart}`;

            const endDateInput = new Date(this.convertDateIntoUtcTimezone(this.reportInfo.endDate));
            const yearEnd = endDateInput.getFullYear();
            const monthEnd = String(endDateInput.getMonth() + 1).padStart(2, '0');
            const dayEnd = String(endDateInput.getDate()).padStart(2, '0');
            const hoursEnd = String(endDateInput.getHours()).padStart(2, '0');
            const minutesEnd = String(endDateInput.getMinutes()).padStart(2, '0');
            const secondsEnd = String(endDateInput.getSeconds()).padStart(2, '0');

            const endDate = `${yearEnd}-${monthEnd}-${dayEnd} ${hoursEnd}:${minutesEnd}:${secondsEnd}`;

            const [taskData] = await Promise.all([
                DashboardService.getPractitionerTransactionSummaryForCompany(
                    this.profile.companyId, startDate, endDate, this.selectedPractitioner)
            ]);

            this.transactionSummary = taskData.data.financialTransactionDtoList;

            this.loading1 = false;
            this.submitted = false;

            this.activeTab = 14;
            this.submitted = false;
        },
        async emailUserFinancialRelatedReport01() {
            this.submitted = true;

            const startDateInput = new Date(this.convertDateIntoUtcTimezone(this.reportInfo.startDate));
            const yearStart = startDateInput.getFullYear();
            const monthStart = String(startDateInput.getMonth() + 1).padStart(2, '0');
            const dayStart = String(startDateInput.getDate()).padStart(2, '0');
            const hoursStart = String(startDateInput.getHours()).padStart(2, '0');
            const minutesStart = String(startDateInput.getMinutes()).padStart(2, '0');
            const secondsStart = String(startDateInput.getSeconds()).padStart(2, '0');

            const startDate = `${yearStart}-${monthStart}-${dayStart} ${hoursStart}:${minutesStart}:${secondsStart}`;

            const endDateInput = new Date(this.convertDateIntoUtcTimezone(this.reportInfo.endDate));
            const yearEnd = endDateInput.getFullYear();
            const monthEnd = String(endDateInput.getMonth() + 1).padStart(2, '0');
            const dayEnd = String(endDateInput.getDate()).padStart(2, '0');
            const hoursEnd = String(endDateInput.getHours()).padStart(2, '0');
            const minutesEnd = String(endDateInput.getMinutes()).padStart(2, '0');
            const secondsEnd = String(endDateInput.getSeconds()).padStart(2, '0');

            const endDate = `${yearEnd}-${monthEnd}-${dayEnd} ${hoursEnd}:${minutesEnd}:${secondsEnd}`;

            try {
                await Promise.all([
                    ReportService.getPractitionerTransactionSummary(
                        this.profile.companyId, startDate, endDate, this.selectedPractitioner)
                ]);

                this.$toast.add({
                    severity: 'success', summary: 'Successful', detail: 'Report Emailed', life: 3000
                });

                this.submitted = false;

            } catch (e) {
                this.$toast.add({
                    severity: 'error',
                    summary: 'Unsuccessful',
                    detail: 'Report NOT Emailed',
                    life: 3000
                });
            }

            this.activeTab = 1;
            this.submitted = false;
        },
        async emailTaskRelatedReport01() {
            var tempUser = "";
            try {
                tempUser = this.reportInfo.user.id;
            } catch (error) {
                tempUser = "";
            }

            const startDateInput = new Date(this.convertDateIntoUtcTimezone(this.reportInfo.startDate));
            const yearStart = startDateInput.getFullYear();
            const monthStart = String(startDateInput.getMonth() + 1).padStart(2, '0');
            const dayStart = String(startDateInput.getDate()).padStart(2, '0');
            const hoursStart = String(startDateInput.getHours()).padStart(2, '0');
            const minutesStart = String(startDateInput.getMinutes()).padStart(2, '0');
            const secondsStart = String(startDateInput.getSeconds()).padStart(2, '0');

            const startDate = `${yearStart}-${monthStart}-${dayStart} ${hoursStart}:${minutesStart}:${secondsStart}`;

            const endDateInput = new Date(this.convertDateIntoUtcTimezone(this.reportInfo.endDate));
            const yearEnd = endDateInput.getFullYear();
            const monthEnd = String(endDateInput.getMonth() + 1).padStart(2, '0');
            const dayEnd = String(endDateInput.getDate()).padStart(2, '0');
            const hoursEnd = String(endDateInput.getHours()).padStart(2, '0');
            const minutesEnd = String(endDateInput.getMinutes()).padStart(2, '0');
            const secondsEnd = String(endDateInput.getSeconds()).padStart(2, '0');

            const endDate = `${yearEnd}-${monthEnd}-${dayEnd} ${hoursEnd}:${minutesEnd}:${secondsEnd}`;

            try {
                await Promise.all([
                    ReportService.getReportTasksForUser(this.profile.companyId, tempUser, startDate, endDate)
                ]);

                this.$toast.add({
                    severity: 'success', summary: 'Successful', detail: 'Report Emailed', life: 3000
                });

            } catch (e) {
                this.$toast.add({
                    severity: 'error',
                    summary: 'Unsuccessful',
                    detail: 'Report NOT Emailed',
                    life: 3000
                });
            }

            this.activeTab = 1;
        },
        async emailTaskRelatedReport02() {
            var tempUser = "";
            try {
                tempUser = this.reportInfo.user.id;
            } catch (error) {
                tempUser = "";
            }

            const startDateInput = new Date(this.convertDateIntoUtcTimezone(this.reportInfo.startDate));
            const yearStart = startDateInput.getFullYear();
            const monthStart = String(startDateInput.getMonth() + 1).padStart(2, '0');
            const dayStart = String(startDateInput.getDate()).padStart(2, '0');
            const hoursStart = String(startDateInput.getHours()).padStart(2, '0');
            const minutesStart = String(startDateInput.getMinutes()).padStart(2, '0');
            const secondsStart = String(startDateInput.getSeconds()).padStart(2, '0');

            const startDate = `${yearStart}-${monthStart}-${dayStart} ${hoursStart}:${minutesStart}:${secondsStart}`;

            const endDateInput = new Date(this.convertDateIntoUtcTimezone(this.reportInfo.endDate));
            const yearEnd = endDateInput.getFullYear();
            const monthEnd = String(endDateInput.getMonth() + 1).padStart(2, '0');
            const dayEnd = String(endDateInput.getDate()).padStart(2, '0');
            const hoursEnd = String(endDateInput.getHours()).padStart(2, '0');
            const minutesEnd = String(endDateInput.getMinutes()).padStart(2, '0');
            const secondsEnd = String(endDateInput.getSeconds()).padStart(2, '0');

            const endDate = `${yearEnd}-${monthEnd}-${dayEnd} ${hoursEnd}:${minutesEnd}:${secondsEnd}`;

            try {
                await Promise.all([
                    ReportService.getReportProcessDurationForUser(this.profile.companyId, tempUser, startDate, endDate)
                ]);

                this.$toast.add({
                    severity: 'success', summary: 'Successful', detail: 'Report Emailed', life: 3000
                });

            } catch (e) {
                this.$toast.add({
                    severity: 'error',
                    summary: 'Unsuccessful',
                    detail: 'Report NOT Emailed',
                    life: 3000
                });
            }

            this.activeTab = 1;
        },
        async emailTaskRelatedReport03() {
            var tempUser = "";
            try {
                tempUser = this.reportInfo.user.id;
            } catch (error) {
                tempUser = "";
            }

            const startDateInput = new Date(this.convertDateIntoUtcTimezone(this.reportInfo.startDate));
            const yearStart = startDateInput.getFullYear();
            const monthStart = String(startDateInput.getMonth() + 1).padStart(2, '0');
            const dayStart = String(startDateInput.getDate()).padStart(2, '0');
            const hoursStart = String(startDateInput.getHours()).padStart(2, '0');
            const minutesStart = String(startDateInput.getMinutes()).padStart(2, '0');
            const secondsStart = String(startDateInput.getSeconds()).padStart(2, '0');

            const startDate = `${yearStart}-${monthStart}-${dayStart} ${hoursStart}:${minutesStart}:${secondsStart}`;

            const endDateInput = new Date(this.convertDateIntoUtcTimezone(this.reportInfo.endDate));
            const yearEnd = endDateInput.getFullYear();
            const monthEnd = String(endDateInput.getMonth() + 1).padStart(2, '0');
            const dayEnd = String(endDateInput.getDate()).padStart(2, '0');
            const hoursEnd = String(endDateInput.getHours()).padStart(2, '0');
            const minutesEnd = String(endDateInput.getMinutes()).padStart(2, '0');
            const secondsEnd = String(endDateInput.getSeconds()).padStart(2, '0');

            const endDate = `${yearEnd}-${monthEnd}-${dayEnd} ${hoursEnd}:${minutesEnd}:${secondsEnd}`;

            try {
                await Promise.all([
                    ReportService.getReportTaskPerformanceForUser(this.profile.companyId, tempUser, startDate, endDate)
                ]);

                this.$toast.add({
                    severity: 'success', summary: 'Successful', detail: 'Report Emailed', life: 3000
                });

            } catch (e) {
                this.$toast.add({
                    severity: 'error',
                    summary: 'Unsuccessful',
                    detail: 'Report NOT Emailed',
                    life: 3000
                });
            }

            this.activeTab = 1;
        }
    }
};
</script>

<style scoped>
a {
    text-decoration: none;
}

.status-badge, .submission-badge {
    border-radius: var(--border-radius);
    padding: .25em .5rem;
    text-transform: uppercase;
    font-weight: 700;
    font-size: 12px;
    letter-spacing: .3px;
}

.status-badge {
    &.status-I {
        background: #FEEDAF;
        color: #8A5340;
    }

    &.status-P {
        background: #C8E6C9;
        color: #256029;
    }

    &.status-W {
        background: #C8E6C9;
        color: #256029;
    }

    &.status-U {
        background: #FFCDD2;
        color: #C63737;
    }

    &.status-S {
        background: #B3E5FC;
        color: #23547B;
    }

    &.status-F {
        background: #ECCFFF;
        color: #694382;
    }

    &.status-M {
        background: #FFD8B2;
        color: #805B36;
    }

    &.status-H {
        background: #ECCFFF;
        color: #694382;
    }

    &.status-H {
        background: #ECCFFF;
        color: #694382;
    }

    &.status-C {
        background: #d9b78a;
        color: #b94f03;
    }

}

.submission-badge {
    &.status-C {
        background: #C8E6C9;
        color: #256029;
    }

    &.status-B {
        background: #FFCDD2;
        color: #C63737;
    }
}

</style>
